/**
 * Item UOM conversion & item-rules API (EMR proxy: /app/api/inventory/...).
 *
 * Backend (inventory-master-service):
 *   GET    /items/{itemId}/uom-conversions
 *   POST   /item-rules  (rule_type: UOM_CONVERSION)
 *   PATCH  /item-rules/{ruleId}
 *   DELETE /item-rules/{ruleId}  (soft delete)
 *   GET    /items/{itemId}/convert
 */
import client, { toInventoryList } from './inventory-request';
import { withStoreCreateBody, withStoreUpdateBody } from '../hooks/useStoreScope';

// GET /inventory/items/{itemId}/uom-conversions/
export async function getItemUomConversions(itemId) {
  const data = await client.get(`/inventory/items/${itemId}/uom-conversions/`);
  return toInventoryList(data);
}

// POST /inventory/item-rules/
export function createItemRule(body) {
  return client.post('/inventory/item-rules/', withStoreCreateBody(body));
}

export function addItemUomConversion(itemId, { from_uom_id, to_uom_id, conversion_factor }) {
  return createItemRule({
    item_id: itemId,
    rule_type: 'UOM_CONVERSION',
    from_uom_id,
    to_uom_id,
    conversion_factor: String(conversion_factor),
    is_base_conversion: false,
  });
}

// PATCH /inventory/item-rules/{ruleId}/
export function updateItemUomConversion(ruleId, { conversion_factor }) {
  return client.patch(
    `/inventory/item-rules/${ruleId}/`,
    withStoreUpdateBody({ conversion_factor: String(conversion_factor) }),
  );
}

// DELETE /inventory/item-rules/{ruleId}/
export function deleteItemUomConversion(ruleId) {
  return client.delete(`/inventory/item-rules/${ruleId}/`);
}

// GET /inventory/items/{itemId}/convert/
export function convertItemUom(itemId, { from_uom_id, to_uom_id, qty = '1' }) {
  return client.get(`/inventory/items/${itemId}/convert/`, {
    from_uom_id,
    to_uom_id,
    qty: String(qty),
  });
}
